module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"roleInstructions":{"headerText":"Instructions"}}}')
  delete Component.options._Ctor
}
